export class DeleteCustomerRequest {
    constructor(
        public customerId: number
    ) {
    }
}
